import { Component, Input, OnInit, OnDestroy  } from '@angular/core';
import { CallModel } from '../shared/models/calllog.model';
import { ClientModel } from '../shared/models/client.model';
import { IssueDetailModel } from '../shared/models/issue.model';
import { ActivatedRoute } from '@angular/router';
import { IssueService } from '../shared/services/issue.service';
import { UserService } from '../shared/services/user.service';
import { UserModel } from '../shared/models/user.model';

@Component({
  selector: 'app-issue',
  templateUrl: './issue.component.html',
  styleUrls: ['./issue.component.css']
})
export class IssueComponent implements OnInit, OnDestroy {
  @Input() call : CallModel;
  
  users : UserModel [];
  issue : IssueDetailModel;
  
  isDetail : boolean;
  id: string;


  private sub: any;

  constructor(
    private userService : UserService,
    private route: ActivatedRoute, 
    private service : IssueService) { }

  ngOnInit() {
    this.isDetail = false;

    this.userService.getUserList().subscribe(
      res=>{
        console.log("getUserList");
        this.users = res as UserModel [];
      },
      err=>{}
    );

    this.sub = this.route.params.subscribe(params => {
     // this.id = +params['id']; // (+) converts string 'id' to a number
      this.id = params['id']; 

      console.log("id : " + this.id);

      if(this.id != null)
      {

        this.service.getDetailData(this.id).subscribe(
          res=>{
            this.issue = res as IssueDetailModel;
            this.isDetail = true;
          },
          err=>{

          }
        );
        
                  
      }
      // In a real app: dispatch action to load the details here.
   });
  }

  afterSelected(data : any)
  {
    console.log("afterSelected");
    if(data == null) // create
    {
      this.isDetail = true;
    }
    else{
      this.issue = data as IssueDetailModel;
      this.isDetail = true;
      if(this.call){
         this.call.callLog.issueId = this.issue.issueId;
         this.call.issue = this.issue;
      }
    }
  }

  afterGoBack(data : any)
  {
    this.isDetail = false;
    this.issue = null;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
